"use strict";

var _interopRequireDefault = require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import empty from './empty.vue'
var _default = {
  props: {
    facade: {
      type: [Object, Array]
    },
    content: {
      type: [Object, Array]
    }
  },
  data: function data() {
    return {
      navigation: [{
        id: 1,
        title: '导航一',
        url: '',
        link: {}
      }]
    };
  },
  computed: {
    navigationData: {
      get: function get() {
        if (this.navigation.length === 0) {
          return [{
            url: '',
            title: '导航一',
            link: {}
          }, {
            url: '',
            title: '导航二',
            link: {}
          }, {
            url: '',
            title: '导航三',
            link: {}
          }, {
            url: '',
            title: '导航四',
            link: {}
          }];
        } else {
          return this.navigation;
        }
      },
      set: function set() {}
    }
  },
  /**
   * 数据监听
   * @type {Object}
   */
  watch: {
    content: {
      deep: true,
      handler: function handler(newV, oldV) {
        this.handleCheck();
      }
    },
    facade: {
      deep: true,
      handler: function handler(newV, oldV) {
        this.handleCheck();
      }
    }
  },
  /**
   * 页面加载执行
   * @return {[type]} [description]
   */
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            this.handleCheck();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {
    handleCheck: function handleCheck() {
      if (this.content.data.length > 0) {
        this.navigation = this.content.data;
      }
      // if (this.facade.nav_style == 2) {
      //   let data = this.content.data;
      //   let l = (this.facade.nav_line * this.facade.nav_line_mun);
      //   this.navigation = data.slice(0, l);
      // }
    },
    getCover: function getCover() {
      var cover = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var url = 'https://img.yzcdn.cn/upload_files/2018/01/22/FnlHRufXMtUI_AbAEP0tux_nDL1T.png!large.webp';
      if (cover) {
        return cover;
      }
      return url;
    }
  }
};
exports.default = _default;